import {
  GET_HAZARD_REPORT,
  GET_HAZARD_REPORT_FAIL,
  GET_HAZARD_REPORT_SUCCESS,
  GET_HAZARD_REPROTS_BY_LOCATION,
  GET_HAZARD_REPROTS_BY_LOCATION_FAIL,
  GET_HAZARD_REPROTS_BY_LOCATION_SUCCESS,
  SAVE_HAZARD_EMAIL,
  SAVE_HAZARD_EMAIL_FAIL,
  SAVE_HAZARD_EMAIL_SUCCESS,
  SUBMIT_REVIEWD_HAZARD_REPORT,
  SUBMIT_REVIEWD_HAZARD_REPORT_FAIL,
  SUBMIT_REVIEWD_HAZARD_REPORT_SUCCESS,
} from "./actionTypes";

export const getHazardReport = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: GET_HAZARD_REPORT,
  payload: { data, onSuccess, onError },
});

export const getHazardReportSuccess = (data = {}) => ({
  type: GET_HAZARD_REPORT_SUCCESS,
  payload: data,
});

export const getHazardReportFail = (data = {}) => ({
  type: GET_HAZARD_REPORT_FAIL,
  payload: data,
});

export const saveHazardEmail = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: SAVE_HAZARD_EMAIL,
  payload: { data, onSuccess, onError },
});

export const saveHazardEmailSuccess = (data = {}) => ({
  type: SAVE_HAZARD_EMAIL_SUCCESS,
  payload: data,
});

export const saveHazardEmailFail = (data = {}) => ({
  type: SAVE_HAZARD_EMAIL_FAIL,
  payload: data,
});

export const submitReviewedHazardReport = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: SUBMIT_REVIEWD_HAZARD_REPORT,
  payload: { data, onSuccess, onError },
});

export const submitReviewedHazardReportSuccess = (data = {}) => ({
  type: SUBMIT_REVIEWD_HAZARD_REPORT_SUCCESS,
  payload: data,
});

export const submitReviewedHazardReportFail = (data = {}) => ({
  type: SUBMIT_REVIEWD_HAZARD_REPORT_FAIL,
  payload: data,
});

export const getHazardReportByLocation = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: GET_HAZARD_REPROTS_BY_LOCATION,
  payload: { data, onSuccess, onError },
});

export const getHazardReportByLocationSuccess = (data = {}) => ({
  type: GET_HAZARD_REPROTS_BY_LOCATION_SUCCESS,
  payload: data,
});

export const getHazardReportByLocationFail = (data = {}) => ({
  type: GET_HAZARD_REPROTS_BY_LOCATION_FAIL,
  payload: data,
});
